<template>
  <div
    data-reveal-item
    class="min-w-0 overflow-hidden rounded-lg border border-[var(--border)] bg-[var(--surface)] p-4 text-center backdrop-blur-md sm:p-5"
  >
    <p class="break-words font-mono text-2xl font-bold text-[var(--accent)] sm:text-3xl">
      <span ref="numEl">{{ display }}</span>
    </p>
    <p class="mt-2 break-words text-xs text-[var(--muted)] sm:text-sm">{{ loc(metric.label) }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { loc, type Metric } from '../data'
import { useCounter } from '../composables/useMotion'

const props = defineProps<{ metric: Metric }>()

const numEl = ref<HTMLElement | null>(null)

const display = computed(() => {
  if (props.metric.staticText) return loc(props.metric.staticText)
  const prefix = props.metric.prefix ?? ''
  const suffix = props.metric.suffix ?? ''
  return `${prefix}${props.metric.value}${suffix}`
})

useCounter(numEl, props.metric.value, (n) => {
  if (!numEl.value || props.metric.staticText) return
  const prefix = props.metric.prefix ?? ''
  const suffix = props.metric.suffix ?? ''
  numEl.value.textContent = `${prefix}${n}${suffix}`
})
</script>
